import type { AdsManagerUser } from "@/api/hooks/adsManager"
import type { MultiSelectOptionGroup } from "@/components/MultiSelectDropdown"

export interface UserFilterOption {
  id: number
  label: string
}

/** Active users first; soft-deleted / inactive users grouped at the bottom. */
export function buildUserFilterGroups(
  users: AdsManagerUser[],
): MultiSelectOptionGroup<number>[] {
  const active: UserFilterOption[] = []
  const deleted: UserFilterOption[] = []

  for (const user of users) {
    const option = {
      id: user.id,
      label: user.label ?? user.username,
    }
    if (user.is_active === false) {
      deleted.push(option)
    } else {
      active.push(option)
    }
  }

  const byLabel = (a: UserFilterOption, b: UserFilterOption) =>
    a.label.localeCompare(b.label)
  active.sort(byLabel)
  deleted.sort(byLabel)

  const groups: MultiSelectOptionGroup<number>[] = []
  if (active.length > 0) {
    groups.push({ label: "Active users", options: active })
  }
  if (deleted.length > 0) {
    groups.push({
      label: "Inactive / deleted",
      options: deleted,
      muted: true,
    })
  }
  return groups
}
